import { View } from "./View";

interface IActivationRequiredWarning {
  title: string;
  subtitle: string;
  urlTarget: string;
}

export const ActivationBanner = (
  props: IActivationRequiredWarning
) => {
  return <View {...props}  />;
};
